/**
 * 创建人：王靖
 * 时间：2019-3-29
 * 描述：消息提示:成功 信息 警告 错误
 * 更新记录: 
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';
declare var $:any;

@Component({
  selector: 'sw-modal',
  templateUrl: './sw-modal.component.html',
  styleUrls: ['./sw-modal.component.css']
})
export class SwModalComponent{
  @Input() message: string; //显示数据
  @Input() type: string; //显示类型  s i w e 
  @Output() voted = new EventEmitter();
  ids:string
  constructor() { }
  ngOnInit(): void {
    //创建唯一id
    this.ids = "modal" + Math.random().toString().split(".")[1];
  }
  /**
   * @ignore
   */
  ngAfterViewInit(){
    this.toggle()
  }

  /**
   * 打开 或者 关闭弹出框
   */
  toggle(){
     $("#"+this.ids).modal("toggle");
     //重置弹出框位置
     if($("#"+this.ids +" .modal-dialog")[0].style!=undefined){
      $("#"+this.ids +" .modal-dialog")[0].style.position="";
      $("#"+this.ids +" .modal-dialog")[0].style.left="";
      $("#"+this.ids +" .modal-dialog")[0].style.top="";
     }
     
  }

  sure(){
    this.toggle()
    this.voted.next(true)
  }

}
